import React, { useEffect, useState } from 'react';
import CoreAccordion from '../../cvp-webgames-core/Components/ui/react/core-accordion';
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { PreCacheManager } from '../../cvp-webgames-core/pre-caching/pre-cache-manager';
import { AnimationState } from '../../cvp-webgames-core/UI/Animation/animation-base';
import { AnimationPage, AnimationPageType } from '../../cvp-webgames-core/UI/Animation/animation-page';
import { getSaveData, saveGame, PageType as PageType, topLeftMenuProps, setVisibilityState, setClosedCaptionState, setMotionState, setVolumeState, setAnimationState, updateLast508Window, setLast508WindowId, disableAnyKeyPress } from '../../misc/tools';
import { BaseConfig } from '../BaseConfig';
import TopLeftControlsUI from '../ui/hud/top-left-controls-ui';
import CoreReturnToMainMenuUI from '../../cvp-webgames-core/Components/ui/react/core-return-to-main-menu-ui';

import "./main-menu-ui.css"
import InitialWindow from './windows/initial-window';
import MainMenuWindow from './windows/main-menu/main-menu-window';
import ResumeGameWindow from './windows/main-menu/resume-game-window';
import SettingsWindow from './windows/main-menu/settings-window';
import StartScenariosWindow from './windows/main-menu/start-scenarios-window';
import AccessibilityWindow from './windows/settings/accessibility-window';
import PreLoadAssetsWindow from './windows/settings/pre-load-assets-window';
import ReferenceMaterialsWindow from './windows/main-menu/reference-materials-window';

enum MainMenuWindowType {
	Initial,

	//Main Menu
	MainMenu,
	StartScenarios,
	Settings,
	ReferenceMaterials,

	//Settings
	Accessibility,
	PreLoadAssets
}

const MainMenuUI = (props: MainMenuUIConfig) => {
	const [animation, setAnimation] = useState(new AnimationPage(AnimationPageType.slide));
	const [mainMenuWindowType, setMainMenuWindowType] = useState(props.isInScenarios ? MainMenuWindowType.StartScenarios : MainMenuWindowType.Initial);
	const [showReturnToMainMenu, setShowReturnToMainMenu] = useState(false);
	const [forceUpdate, setForceUpdate] = useState(false);

	let mmString = '';
	let mmColor = '';

	if(mainMenuWindowType === (MainMenuWindowType.Initial || MainMenuWindowType.MainMenu)) {
		mmString = 'main-menu-button';
		mmColor = 'make-grey';
	} else {
		mmString = '';
		mmColor = '';
	}
	
	const updateMainMenuWindowType = (type: MainMenuWindowType) => {
		disableAnyKeyPress();

		animation.setState(AnimationState.Out, ()=> {
			setMainMenuWindowType(type)
			setTimeout(() => {
				updateLast508Window();
			}, 1000);
		});
	}
	const renderCurrentWindow = () => {
		var savedData = getSaveData();

		switch(mainMenuWindowType)
		{
			case MainMenuWindowType.Initial:
				return (<InitialWindow animation={animation} onClick={(isAccessbilityEnabled: boolean) => {
					if(getSaveData().isMotionEnabled) {
						document.getElementsByTagName('video')[0].play();
					}
					
					setVisibilityState(isAccessbilityEnabled);
					updateMainMenuWindowType(MainMenuWindowType.MainMenu)
				}}></InitialWindow>);

			//Main Menu
			case MainMenuWindowType.MainMenu:
				return (<MainMenuWindow
							animation={animation}
							onStartScenariosClicked={() => {
								setLast508WindowId('main-menu-window-top');
								updateMainMenuWindowType(MainMenuWindowType.StartScenarios)
							}}
							isResumeUnlocked={savedData.lastVisitedScenarioIndx >= 0}
							onResumeGameClicked={() => {
								Tools.updateWindow(savedData.scenarios[savedData.lastVisitedScenarioIndx].scenarioWindow);
							}}
							onSettingsClicked={() => {
								setLast508WindowId('main-menu-window-top');
								updateMainMenuWindowType(MainMenuWindowType.Settings)
							}}
							onReferenceMaterialsClicked={() => {
								setLast508WindowId('main-menu-window-top');
								updateMainMenuWindowType(MainMenuWindowType.ReferenceMaterials)
							}}></MainMenuWindow>);
			case MainMenuWindowType.StartScenarios:
				return (<StartScenariosWindow
							animation={animation}
							onReturnToPreviousMenuClicked={() => updateMainMenuWindowType(MainMenuWindowType.MainMenu)}
							onStartScenarioClicked={(page: PageType, scenarioIndx: number) => {
								const savedData = getSaveData();
								savedData.lastVisitedScenarioIndx = scenarioIndx;
								saveGame(savedData);
								props.updateWindow(page)
							}}
							updateWindow={props.updateWindow}></StartScenariosWindow>);
			case MainMenuWindowType.Settings:
				return (<SettingsWindow
							animation={animation}
							onAccessibilityClicked={() => updateMainMenuWindowType(MainMenuWindowType.Accessibility)}
							onPreloadClicked={() => updateMainMenuWindowType(MainMenuWindowType.PreLoadAssets)}
							onReturnToMainMenu={() => updateMainMenuWindowType(MainMenuWindowType.MainMenu)}></SettingsWindow>);
			case MainMenuWindowType.ReferenceMaterials:
				return (<ReferenceMaterialsWindow
							animation={animation}
							onReturnToMainMenu={() => updateMainMenuWindowType(MainMenuWindowType.MainMenu)}></ReferenceMaterialsWindow>);
			//Settings
			case MainMenuWindowType.Accessibility:
				return (<AccessibilityWindow
							animation={animation}
							defaultIsVisibleFocusEnabled={savedData.isVisibleFocusEnabled}
							defaultIsAudioEnabled={savedData.isAudioEnabled}
							defaultIsCCEnabled={savedData.isClosedCaptionEnabled}
							defaultIsMotionEnabled={savedData.isMotionEnabled}
							defaultIsAnimationsEnabled={savedData.isAnimationsEnabled}
							onSetAnimations={(isEnabled: boolean) => setAnimationState(isEnabled)}
							onSetVisibleFocus={(isEnabled: boolean) => setVisibilityState(isEnabled)}
							onSetAudio={(isEnabled: boolean) => setVolumeState(isEnabled)}
							onSetCC={(isEnabled: boolean) => setClosedCaptionState(isEnabled)}
							onSetMotion={(isEnabled: boolean) => setMotionState(isEnabled)}
							onReturnToPreviousMenuClicked={() => updateMainMenuWindowType(MainMenuWindowType.Settings)}></AccessibilityWindow>);
			case MainMenuWindowType.PreLoadAssets:
				return (<PreLoadAssetsWindow
							animation={animation}
							onPreloadingFinished= {() => {}}
							preCacheManager={props.preCacheManager}
							onReturnToPreviousMenuClicked={() => (updateMainMenuWindowType(MainMenuWindowType.Settings))}></PreLoadAssetsWindow>)

		}		
	}

	return (
		<div className="modal-disable-select main-menu-ui-container" style={{
		}}>
			<TopLeftControlsUI id={Tools.generateGuid()} dispatch={null} key={Tools.generateGuid()} parameters={topLeftMenuProps(null, () => {
				if (mainMenuWindowType === (MainMenuWindowType.Initial || MainMenuWindowType.MainMenu)) {
					setShowReturnToMainMenu(false);
				} else setShowReturnToMainMenu(true);
			}, () => {
				if((window as any)['forceEntireUIRefresh']) {
					(window as any)['forceEntireUIRefresh']();
				}
			}, mmString, mmColor)}></TopLeftControlsUI>
			{showReturnToMainMenu ?<CoreReturnToMainMenuUI id={Tools.generateGuid()} dispatch={null} key={Tools.generateGuid()} parameters={{
				topId: 'return-to-main-menu-content-top',
				bottomId: 'return-to-main-menu-content-bottom', 
				onGoToMainMenuClicked: () => {
					props.updateWindow(PageType.MainMenu);
					setShowReturnToMainMenu(false);
				},
				onCancelClicked: () => {
					setShowReturnToMainMenu(false);
				}
			}}></CoreReturnToMainMenuUI> : null}

			{renderCurrentWindow()}
		</div>
	);

};

export interface MainMenuUIConfig extends BaseConfig{
	updateWindow: (windowToUse: PageType) => void;
	isInScenarios: boolean;
	preCacheManager: PreCacheManager;
}

export default MainMenuUI;